import { at, uniq } from 'lodash';

export const getCurrentUser = ({ users }) => users.byId[users.current];

export const getCurrentUserPurchases = ({ users, userPurchases, purchases }) => {
  const userPurchaseIds = uniq(userPurchases.byUserId[users.current]);
  return at(purchases.byId, userPurchaseIds);
};



// WEBPACK FOOTER //
// ./src/selectors/user-selector.js